import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import es from "./ar.json";
import en from "./en.json";

const DICTS = { ar: es, en };
const LANGS = ["ar", "en"];

const I18nContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] != null ? acc[key] : undefined), obj);
}

export function I18nProvider({ lang, children }) {
  const [language, setLanguage] = useState(lang || "ar");

  useEffect(() => {
    if (lang && lang !== language) setLanguage(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    const htmlLang = DICTS[language]?.meta?.lang || "es";
    document.documentElement.setAttribute("lang", htmlLang);
    // Update page title based on language
    const titles = {
      ar: "Ronaviraxa — Crowdlending inmobiliario en Argentina",
      en: "Ronaviraxa — Real estate crowdlending in Argentina",
    };
    const descs = {
      ar: "Ronaviraxa — Crowdlending inmobiliario en Argentina. Participá en proyectos residenciales, obras y desarrollos urbanos con aportes proporcionales, información clara y seguimiento digital.",
      en: "Ronaviraxa — Real estate crowdlending in Argentina. Take part in residential works, refurbishments and urban developments with proportional contributions, clear information and digital tracking.",
    };
    if (titles[language]) document.title = titles[language];
    const meta = document.querySelector('meta[name="description"]');
    if (meta && descs[language]) meta.setAttribute("content", descs[language]);
  }, [language]);

  const t = useCallback(
    (key, fallback) => {
      const val = resolve(DICTS[language], key);
      if (val === undefined || val === null) return fallback !== undefined ? fallback : key;
      return val;
    },
    [language]
  );

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      t,
      langs: LANGS,
      dict: DICTS[language],
    }),
    [language, t]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export { LANGS };
